import { useMemo, useState } from 'react';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import { getBuoyDevices } from '../features/Buoy/graph/buoyGraphUtils';
import AllBuoysMap from '../features/Buoy/map/index.web';

const BuoyMapWidget = () => {
  const { data: connectedDevices = [] } = useGetConnectedDevicesQuery();
  const buoyDevices = useMemo(() => getBuoyDevices(connectedDevices), [connectedDevices]);
  const [searchValue, setSearchValue] = useState('');
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [activeControl, setActiveControl] = useState('search');

  const sortedBuoyDevices = useMemo(
    () =>
      [...buoyDevices].sort((a, b) =>
        String(a.alias || a.name || a.ext_id || '')
          .toLowerCase()
          .localeCompare(String(b.alias || b.name || b.ext_id || '').toLowerCase()),
      ),
    [buoyDevices],
  );

  const handleSearch = () => {
    const query = searchValue.trim().toLowerCase();
    if (!query) return;
    const match = sortedBuoyDevices.find((device) =>
      [device.alias, device.name, device.ext_id, device.node_id]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(query)),
    );
    if (match) {
      setSelectedDeviceId(String(match.id));
    }
  };

  return (
    <div className="h-100 w-100 d-flex flex-column gap-2">
      {/* Widget search controls intentionally hidden for now.
      <div className="d-flex gap-1 flex-shrink-0 pt-1">
        <div
          className="d-flex align-items-center bg-primary rounded-3 px-2 py-0 overflow-hidden"
          onClick={() => setActiveControl('search')}
          style={{
            flex: activeControl === 'search' ? '1 1 auto' : '0 0 38px',
            minWidth: activeControl === 'search' ? 0 : 38,
            cursor: 'text',
            transition: 'flex-basis 180ms ease, width 180ms ease',
            justifyContent: activeControl === 'search' ? 'flex-start' : 'center',
            minHeight: 34,
            gap: activeControl === 'search' ? 8 : 0,
          }}
        >
          <div
            className="d-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: 16, height: 16 }}
          >
            <BsSearch className="text-white" size={16} />
          </div>
          {activeControl === 'search' && (
            <>
              <Form.Control
                type="search"
                placeholder="Search buoy name or ID"
                aria-label="Search buoy device"
                value={searchValue}
                autoFocus
                size="sm"
                style={{ minHeight: 28, fontSize: 13, paddingInline: 10 }}
                onFocus={() => setActiveControl('search')}
                onChange={(event) => setSearchValue(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    handleSearch();
                  }
                }}
              />
              <Button
                variant="primary"
                size="sm"
                className="flex-shrink-0"
                style={{ paddingInline: 12 }}
                onClick={handleSearch}
              >
                Search
              </Button>
            </>
          )}
        </div>
        <div
          className="d-flex align-items-center bg-primary rounded-3 px-2 py-0 overflow-hidden"
          onClick={() => setActiveControl('dropdown')}
          style={{
            flex: activeControl === 'dropdown' ? '1 1 auto' : '0 0 38px',
            minWidth: activeControl === 'dropdown' ? 0 : 38,
            cursor: 'pointer',
            transition: 'flex-basis 180ms ease, width 180ms ease',
            justifyContent: activeControl === 'dropdown' ? 'flex-start' : 'center',
            minHeight: 34,
            gap: activeControl === 'dropdown' ? 8 : 0,
          }}
        >
          <div
            className="d-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: 18, height: 18 }}
          >
            <BsChevronDown className="text-white" size={18} />
          </div>
          {activeControl === 'dropdown' && (
            <Form.Select
              aria-label="Select buoy device"
              value={selectedDeviceId}
              autoFocus
              size="sm"
              style={{ minHeight: 28, fontSize: 13, paddingInline: 10 }}
              onFocus={() => setActiveControl('dropdown')}
              onChange={(event) => setSelectedDeviceId(event.target.value)}
            >
              <option value="">All buoy devices</option>
              {sortedBuoyDevices.map((device) => (
                <option key={device.id} value={device.id}>
                  {device.alias || device.name || device.ext_id || `Buoy ${device.id}`}
                </option>
              ))}
            </Form.Select>
          )}
        </div>
      </div>
      */}
      <div className="bg-primary rounded-3 overflow-hidden w-100 h-100">
        <AllBuoysMap
          widget
          showTimeUpdate={false}
          selectedDeviceId={selectedDeviceId}
        />
      </div>
    </div>
  );
};

export default BuoyMapWidget;
